import * as React from 'react';
import { useRef } from 'react';
import { confirmable } from 'react-confirm';
import DeleteButton from '../components/deleteButton';
import IconFontAwesome from "./iconFontAwesome";
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react'

type Props = {
	show: boolean,
	proceed: (value: any) => void,
	cancel: (value: any) => void,
	dismiss: () => void,
	confirmation: string,
	options: {
		buttonLabelYes: string,
		buttonLabelNo: string,
		description?: string,
	},
}

function ConfirmDeleteDialog({show, proceed, confirmation, options}: Props) {

	const cancelButtonRef = useRef(null);

	return (
		<Dialog open={show} onClose={() => proceed(false)} className="relative z-50" initialFocus={cancelButtonRef}>
			<DialogBackdrop className="fixed inset-0 bg-overlay"/>

			<div className="fixed inset-0 flex w-screen items-center justify-center overflow-y-auto">
				<DialogPanel className="w-full max-w-md bg-white shadow-lg relative m-4">
					<DeleteButton onClick={() => proceed(false)} className="absolute right-2 top-2"/>

					<div className="p-8">
						<div className="flex justify-start items-center">
							<IconFontAwesome className="fa-solid icon-question text-6xl !text-grey-400 mr-8"/>
							<div>
								<div className="my-0 text-2xl">{confirmation}</div>
								{options.description && <div className="mt-3 mb-0">{options.description}</div>}
							</div>
						</div>
					</div>

					<div className="px-6 py-5 bg-grey-100 text-right">
						<button className="bg-white" ref={cancelButtonRef} onClick={() => proceed(false)}>{options.buttonLabelNo}</button>
						<button className="error ml-6" onClick={() => proceed(true)}>{options.buttonLabelYes}</button>
					</div>
				</DialogPanel>
			</div>
		</Dialog>
	);
}

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
export default confirmable(ConfirmDeleteDialog);

